import React ,{useEffect,useState, useCallback} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import defaultStyles from './independentAmount.module.scss';
import {independentAmountConnected, refreshIndependentAmount,setRowChecked, setAllRowsChecked,setActiveValue, exportCalcReports, setGridSorts, exportReport} from './actions'
import GridHeader from '../common/gridheader/GridHeader';
import Grid from '../webcommon/grid/Grid';
import { getTimeStamp } from '../webcommon/common/helpers';
import * as selectors from './selectors'
import {getDefaultSort,getDateFrom,} from './selectors'
import { findGridSort } from "../common/helpermethods/HelperMethods"
import FilterHeader from '../webcommon/header/filterheader/FilterHeader';
import { getFilters } from '../webcommon/header/filterheader/selectors';
import SimpleGridHeaderButton from '../common/gridheader/simplegridheader/SimpleGridHeaderButton';
import { ReactComponent as Export } from '../webcommon/common/Icons/Export.svg';
import ActionButton from '../webcommon/common/actionbutton/ActionButton';


const IndependentAmount = (props)=> {

    const {independentAmountConnected, location, setAllRowsChecked, exportCalcReports, exportReport} = props;            
    const [allRowsChecked, setAllRowsCheckedFunc] = useState(false);
    useEffect(() => {
        independentAmountConnected(location.search);
    },[independentAmountConnected, location]);

    const setHeaderChecked = useCallback((checked) => {
        setAllRowsChecked(checked);
        setAllRowsCheckedFunc(checked);
    }, [setAllRowsChecked, setAllRowsCheckedFunc]);  


    let atLeastOneReportChecked = props.rowsIndependentAmount.some(row => row.selected)
    let reportsSelected = props.rowsIndependentAmount.filter( row => row.selected).map(row => row.reportFileName)

    return (
        <div className={props.styles.wrapper}>
            <div className={props.styles.filter}>                      
                <FilterHeader
                    fixed
                    title="Data Load Filters"
                    id="IndependentAmount"/>                                          
                <div>
                    <div className={props.styles.gridHeader}>
                        <GridHeader
                            title="Independent Amount Results"   
                            refreshControlsActive
                            refreshData={ props.refreshIndependentAmount }  
                            lastUpdated={ props.lastUpdated } >
                                {atLeastOneReportChecked &&
                            <SimpleGridHeaderButton
                                onClick={ () => {exportCalcReports(reportsSelected)} }
                                text="Export Report"                                
                            >
                                <Export />
                            </SimpleGridHeaderButton>}
                        {!atLeastOneReportChecked &&
                            <SimpleGridHeaderButton
                                onClick={ () => {} }
                                text="Select Calc Reports to export"                                
                            >                                
                            </SimpleGridHeaderButton>}
                        </GridHeader>           
                    </div>
                    <div className={props.styles.grid}>
                        <Grid
                            sortable
                            columns={props.columnsIndependentAmount}
                            rows={props.rowsIndependentAmount}
                            loading={ props.loading }
                            defaultSorted={ findGridSort(props.defaultSort, 'timestampSort') }
                            onSortedChange={ (newSorted) => {props.setGridSorts('timestampSort', newSorted);} }
                            headerChecked={ allRowsChecked }
                            setHeaderChecked={ setHeaderChecked }
                            setRowChecked={ props.setRowChecked }
                        />
                    </div>                    
                    <div className={props.styles.buttonWrapper}>
                        {props.downgrade.available && 
                        <div className={props.styles.button2}>
                            <ActionButton onClick={() => {exportReport(props.downgrade)}}>
                                &nbsp;&nbsp;Downgrade Report Available&nbsp;&nbsp;
                            </ActionButton>
                        </div>}                     
                        {props.otcIa.available && 
                        <div className={props.styles.button2}>
                            <ActionButton onClick={() => {exportReport(props.otcIa)}}>
                                &nbsp;&nbsp;OTC File Available&nbsp;&nbsp;
                            </ActionButton>
                        </div>
                        }
                     </div>
                </div>                               
            </div>      
        </div>       
        ); 
}
IndependentAmount.propTypes = {
    location: PropTypes.shape({
        search: PropTypes.string
    }).isRequired,
    independentAmountConnected: PropTypes.func.isRequired,
    styles: PropTypes.objectOf(PropTypes.string)    
};

IndependentAmount.defaultProps = {
     styles: defaultStyles,
     dateProp: '',
     lastUpdated: getTimeStamp(),
};

const mapDispatchToProps = {
    independentAmountConnected,
    refreshIndependentAmount,
    setActiveValue,
    setRowChecked,
    setAllRowsChecked,
    exportCalcReports,
    setGridSorts,
    exportReport
};

const mapStateToProps = state => ( 
    {  
        columnsIndependentAmount: selectors.combinedColumnsSelector(state),
        rowsIndependentAmount: state.independentAmount.rowsIndependentAmount,
        loading: state.independentAmount.loadingIndependentAmount,
        lastUpdated: selectors.getIndependentAmountLastUpdated(state),
        defaultSort: getDefaultSort(state),
        runDate: getDateFrom(getFilters(state, 'IndependentAmount')),
        downgrade: state.independentAmount.downgrade,
        otcIa: state.independentAmount.otcIa

    }
)

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(IndependentAmount));
